import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import './ImagePreviewModal.css';

const ImagePreviewModal = ({ imageSrc, imageInfo = [] }) => {
  return (
    <div>
      <PhotoProvider
        maskOpacity={0.8}
        pullClosable={false}
        maskClosable={false}
        toolbarRender={({ onScale, scale, rotate, onRotate }) => {
          return (
            <div
              style={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center'
                // paddingTop: '16px'
              }}
            >
              <button
                className="rotation-btn"
                onClick={() => onRotate(rotate - 90)}
                aria-label="Rotate left 90 degrees"
              >
                ↺ 90°
              </button>
              <button
                className="rotation-btn"
                onClick={() => onScale(scale + 1)}
                aria-label="zoom in"
              >
                +
              </button>
              <button
                className="rotation-btn reset-btn"
                onClick={() => {
                  onScale(0);
                  onRotate(0);
                }}
                aria-label="Reset rotation and zoom"
              >
                Reset
              </button>
              <button
                className="rotation-btn"
                onClick={() => onScale(scale - 1)}
                aria-label="Zoom out"
              >
                -
              </button>
              <button
                className="rotation-btn"
                onClick={() => onRotate(rotate + 90)}
                aria-label="Rotate left 90 degrees"
              >
                90° ↻
              </button>
            </div>
          );
        }}
        overlayRender={() => (
          <div
            className="info-panel"
            style={{
              position: 'absolute',
              right: '8px',
              top: '70px',
              maxHeight: '80vh',
              borderRadius: '8px',
              zIndex: 9999
            }}
          >
            {imageInfo && imageInfo.length > 0 && (
              <>
                {/* <h3 className="info-title">Image Information</h3> */}
                <div className="info-content">
                  {imageInfo.map((info, index) => (
                    info.title ? <h3 className="info-title">{info.title}</h3> :
                      <div key={index} className="info-item">
                        <span className="info-label">{info.label}:</span>
                        <span className="info-value">{info.value || 'N/A'}</span>
                      </div>
                  ))}
                </div>
              </>
            )}
          </div>
        )}
      >
        <PhotoView src={imageSrc}>
          <button
            style={{
              padding: '0 8px',
              fontSize: '14px',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: '#4195f5',
              color: '#fff',
              height: '32px',
              marginTop: '-22px'
            }}
          >
            Preview
          </button>
        </PhotoView>
      </PhotoProvider>
    </div>
  );
};

export default ImagePreviewModal;
